export default function AwardsSection({ awards }) {
    if (!awards?.length) return null;

    return (
        <div className="award-grid" id='rewardsElement'>
            {awards.map((award, index) => (
                <div className="award-item" key={index}>
                    <div className="award-img-box">
                        <img
                            src={award.imagePath ? ("data:image/png;base64," + award.imagePath) : "/assets/img/default-award.png"}
                            alt={award.title}
                            onError={(e) => { e.target.src = "/assets/img/default-award.png"; }}
                            className="award-img"
                        />
                    </div>
                    <div className="award-info">
                        <h4 className="award-title">{award.title}</h4>
                        <p className="award-desc">{award.description}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}